// import React,{useState,useEffect} from 'react'
// import classes from './Subscribe.module.css'
// import Navbar from '../Components/Navbar'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import axios from 'axios'
// import Cookies from 'js-cookie';
// import { useNavigate } from 'react-router-dom';
// import { check_subscription_api } from '../Services/Apis';
// import { v4 as uuidv4 } from 'uuid';
// import { generateRandomString } from '../Components/RandomStringGenerator';


// const Subscribe = () => {

//     const [number,setNumber] = useState('');
//     const params = new URLSearchParams(window.location.search)
//     let extId = params.get('ext_ref') 

//     extId = (!extId || extId === "null") ? generateRandomString() : extId;



//     console.log(extId)

//     const navigate = useNavigate()

//     const CheckUser=async()=>{
//       try{
         
//               const response = await axios.get(`${check_subscription_api}?msisdn=${number}`);
//               if(response.data == 'SUCCESS' || response.data == 'success' || response.data == 'Success'){
//                   Cookies.set('sub_number',number,{expires:1});
//                   navigate('/home')
//               }
//               else{
//                   navigate(`/pack?msisdn=${number}&ext_ref=${extId}`)
//               }
//       }
//       catch(err){
//           console.log(err);
//           if(err.response.status == 404){
//             navigate(`/pack?msisdn=${number}&ext_ref=${extId}`)
//           }
//           else if(err.response.status == 402 || err.response.status == 403){
//             toast.error("INSUFFICIENT BALANCE!!");
//           }
//       }
//   }
    

//     const handleSubmit=(e)=>{
//       e.preventDefault();
//       if(number == ''){
//         toast.error('Please First Enter Your Number!!')
//         return;
//       }

//       CheckUser()

//       // Cookies.set('number',number);
//       // navigate(`/pack?ext_ref=${extId}&msisdn=${number}`)
//       // console.log('submitHandler called!!')
//     }

//   return (
//     <div className={classes.container}>
//     <Navbar/>
//     <div className={classes.main}>
//     <div className={classes.subscribe}>
//    <div className={classes.text}>Subscribe Now</div>
// </div>




//     </div>

//    <div className={classes.form_div}>
//    <form className={classes.form} onSubmit={handleSubmit}>
// <p className='text-xl text-center'>Enter your Mobile Number</p>

// <input type="text" value={number} placeholder='260****' className={classes.input} onChange={(e)=>setNumber(e.target.value)}/>
// <button className={classes.btn} >
//     Submit
// </button>
// </form>
//    </div>

//     {/* <ToastContainer/> */}
//     </div>
//   )
// }

// export default Subscribe




import React, { useState } from 'react'
import classes from './Subscribe.module.css'
import Navbar from '../Components/Navbar'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { check_subscription_api } from '../Services/Apis';
import { generateRandomString } from '../Components/RandomStringGenerator';

const Subscribe = () => {

    const [number, setNumber] = useState('');
    
    // NEW STATE
    const [paymentType, setPaymentType] = useState('airtime');

    const params = new URLSearchParams(window.location.search)

    let extId = params.get('ext_ref')

    extId = (!extId || extId === "null")
        ? generateRandomString()
        : extId;

    console.log(extId)

    const navigate = useNavigate()

    const CheckUser = async () => {

        try {

            const response = await axios.get(
                `${check_subscription_api}?msisdn=${number}`
            );

            if (
                response.data == 'SUCCESS' ||
                response.data == 'success' ||
                response.data == 'Success'
            ) {

                Cookies.set('sub_number', number, { expires: 1 });

                navigate('/home')

            } else {

                navigate(
                    `/pack?msisdn=${number}&ext_ref=${extId}&paymentType=${paymentType}`
                )
            }

        }
        catch (err) {

            console.log(err);

            if (err.response.status == 404) {

                navigate(
                    `/pack?msisdn=${number}&ext_ref=${extId}&paymentType=${paymentType}`
                )

            }
            else if (
                err.response.status == 402 ||
                err.response.status == 403
            ) {

                toast.error("INSUFFICIENT BALANCE!!");
            }
        }
    }

    const handleSubmit = (e) => {

        e.preventDefault();

        if (number == '') {

            toast.error('Please First Enter Your Number!!')
            return;
        }

        CheckUser()
    }

    return (

        <div className={classes.container}>

            <Navbar />

            <div className={classes.main}>

                <div className={classes.subscribe}>
                    <div className={classes.text}>
                        Subscribe Now
                    </div>
                </div>

            </div>

            <div className={classes.form_div}>

                <form
                    className={classes.form}
                    onSubmit={handleSubmit}
                >

                    <p className='text-xl text-center'>
                        Enter your Mobile Number
                    </p>

                    <input
                        type="text"
                        value={number}
                        placeholder='260****'
                        className={classes.input}
                        onChange={(e) => setNumber(e.target.value)}
                    />

                    {/* PAYMENT OPTIONS */}

                    <div
                        style={{
                            display: 'flex',
                            gap: '20px',
                            marginTop: '15px',
                            marginBottom: '15px',
                            justifyContent: 'center'
                        }}
                    >

                        <label
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                cursor: 'pointer'
                            }}
                        >
                            <input
                                type="radio"
                                name="paymentType"
                                value="airtime"
                                checked={paymentType === 'airtime'}
                                onChange={(e) =>
                                    setPaymentType(e.target.value)
                                }
                            />

                            Airtime
                        </label>

                        <label
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                cursor: 'pointer'
                            }}
                        >
                            <input
                                type="radio"
                                name="paymentType"
                                value="momo"
                                checked={paymentType === 'momo'}
                                onChange={(e) =>
                                    setPaymentType(e.target.value)
                                }
                            />

                            MoMo
                        </label>

                    </div>

                    <button className={classes.btn}>
                        Submit
                    </button>

                </form>

            </div>

        </div>
    )
}

export default Subscribe
